import { merge } from 'lodash-es'

import BillingClickCapture from 'components/billing/click_capture'
import { ActivationToggleItem, buildNotification } from 'components/event_type_edit'
import { useUpdateEventTypeMutation } from 'features/event_type_editor/api'
import { useEventType } from 'features/event_type_provider'

import { notificationToggleToServerData } from './subsections/config'
import { getActivationFeatureKey, getActivationPaywallName } from './subsections/upgrade_enforcement'

const toggleActivation = ({ updateEventType, eventType, name, activated }) => {
  const notification = buildNotification(eventType, name)
  notification.enabled = activated

  const attributes = merge(
    { custom_notifications: eventType.custom_notifications },
    { ...notificationToggleToServerData(notification) }
  )

  return updateEventType({ eventType, attributes })
}

export const BillingWrappedActivationToggleItem = ({ kind, active, onSubmit, doNotSlideBackOnUpdate = false }) => {
  const eventType = useEventType()
  const [defaultUpdateEventType] = useUpdateEventTypeMutation({ id: eventType.id })

  const wrappedOnSubmit = ({ eventType: et, attributes }) => {
    onSubmit({ ...et, ...attributes }, { preventSelectionPopOnUpdate: doNotSlideBackOnUpdate })
  }

  const updateEventType = onSubmit ? wrappedOnSubmit : defaultUpdateEventType

  const handleActivation = (activated) => () => toggleActivation({
    updateEventType,
    eventType,
    name: kind,
    activated,
  })

  return (
    <BillingClickCapture
      featureName={getActivationFeatureKey(kind)}
      paywallOverride={getActivationPaywallName(kind)}
      skipPreface
      noTracking
    >
      <ActivationToggleItem
        active={active}
        updateLabel
        activate={handleActivation(true)}
        deactivate={handleActivation(false)}
      />
    </BillingClickCapture>
  )
}
